import Carteira from './Carteira';

export default Carteira;
